import React from 'react';

import {Icon, Envelope, EnvelopeClock, CycleMini} from '@optimaxdev/icons';

import classNames from 'classnames';

import {CartItemEyeglassesType} from '../../types';

import {getCoPayValue} from './helpers';
import * as CoverageIcon from './icon/coverage.svg';
import * as ExclamationMarkIcon from './icon/exclamationMark.svg';
import * as FrameAttentionIcon from './icon/frameAttention.svg';
import * as WearTearIcon from './icon/wearTear.svg';

import s from './getFeatures.scss';

type PropsType = {
    icon: React.ReactNode;
    title: React.ReactNode;
    description?: string;
    size: string;
};

const PackageBenefits: React.FC<PropsType> = ({description = '', icon, size, title}) => {
    return (
        <div className={s.container}>
            <div className={classNames(s.icon, size)}>{icon}</div>
            <div className={s.title}>{title}</div>
            {description && <div className={s.description}>{description}</div>}
        </div>
    );
};

/**
 * Displays benefits for insurance popup
 * @returns {ReactNode} - node
 */
export const Benefits = () => (
    <div className={s.benefits}>
        <PackageBenefits
            icon={<Icon icon={WearTearIcon} />}
            size={s.wearTear}
            title="Damage from normal day-to-day wear & tear"
        />
        <PackageBenefits
            icon={<Icon icon={CycleMini} />}
            size={s.rxChange}
            title="Changes to your glasses prescription"
        />
        <PackageBenefits
            icon={<Icon icon={ExclamationMarkIcon} />}
            size={s.exclamationMark}
            title="Accidental damage from handling"
        />
        <PackageBenefits
            icon={<Icon icon={CoverageIcon} />}
            size={s.coverage}
            title="Warranty starts upon receiving the glasses"
        />
    </div>
);

/**
 * function that returns features data
 */
export const getFeatures = (
    item?: CartItemEyeglassesType,
    isPremiumItem?: boolean,
    lensColorSku?: string,
) => {
    return [
        {
            className: s.glasses,
            description:
                'If your glasses break from normal wear and tear within the warranty coverage period, you can return your glasses and get a suitable replacement. Just give us a call and we’ll start the exchange process.',
            icon: <Icon icon={FrameAttentionIcon} role="presentation" />,
            title: 'So my glasses broke, now what?',
        },
        {
            className: s.rx,
            description:
                'If your eye doctor gave you a new prescription within the warranty coverage period, just give our expert customer service reps a call and we’ll start the exchange process.',
            icon: <Icon icon={CycleMini} role="presentation" />,
            title: 'My RX seems off, can I get new lenses put in?',
        },
        {
            className: s.mail,
            description: `Feel free to send your glasses back through a postal service of your choice. Make sure to get a tracking number so that we can see where the glasses are in transit. You will need to supply a co-pay of $${getCoPayValue(
                item,
                isPremiumItem,
                lensColorSku,
            )} for replacement service (incl. handling)`,
            icon: <Icon icon={Envelope} role="presentation" />,
            title: 'How do I send them back?',
        },
        {
            className: s.mailApprove,
            description:
                'Please ship the glasses to: Optimax Fulfillment Services 2050 S. Mt Prospect Road STE D Des Plaines, Illinois 60018, USA',
            descriptionClass: s.mailApproveDescription,
            icon: <Icon icon={EnvelopeClock} role="presentation" />,
            title: 'Where do I send them?',
        },
    ];
};
